<template>
        <div class="mainpage">
            <div class="whitebox">
                <h1>My Test Results</h1>
                <ul class="test_hisstory" v-show="list.length>0">
                    <li v-for="(i, index) in list" :key="index">
                        {{index+1}}.
                        <router-link :to="{path:`/result/${i.id}`}" >My Test Results on {{i.datetime | date}}</router-link></li>
                </ul>
                <h3 v-show="list.length==0">Ooops! There are no test results yet!</h3>
                <button @click="newTest">Start a New Test</button>
            </div><!--whitebox end--->
        </div><!--mainpage end---><!--mainpage end--->
</template>
<script>
    import util from '../util';
    import config from '../config';
    import timestamp from 'time-stamp';

    export default {
        name:"test_history",
        data(){
            return {
                list:[],
            }
        },
        filters:{
            date(v){
                return timestamp('MM/DD/YYYY',new Date(v));
            }
        },
        methods:{
            getData(){
                util.axios.post(config.test_history_url)
                    .then((data)=>{
                        if(data){
                            this.list = data;
                        }
                    })
            },
            newTest(){
                this.$router.push('/test');
            }
        },
        mounted(){
            this.getData();
        }
    }
</script>

<style scoped>

</style>
